import { createFileRoute, useParams } from '@tanstack/react-router'

import { MyGrowerDetailScreen } from './-my-grower-detail-screen'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId',
)({
    component: MyGrowerDetailPage,
})

function MyGrowerDetailPage() {
    const { growerId } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId',
    })
    return <MyGrowerDetailScreen growerId={growerId} />
}
